import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  UserGroupIcon,
  CalendarDaysIcon,
  ClipboardDocumentCheckIcon,
  CurrencyDollarIcon,
  BanknotesIcon
} from '@heroicons/react/24/outline';

interface PayrollCardProps {
  title: string;
  description: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  href: string;
}

const PayrollCard: React.FC<PayrollCardProps> = ({ title, description, icon: Icon, href }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(href)}
      className="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-shadow border border-gray-200"
    >
      <div className="flex items-start">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <div className="p-2 bg-blue-50 rounded-lg">
              <Icon className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  );
};

const Payroll: React.FC = () => {
  return (
    <div className="p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Payroll Management</h1>
        <p className="text-gray-600 mt-1">Manage employees, attendance, leaves, salaries, and advance payments</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <PayrollCard
          title="Employees"
          description="Manage employee master data"
          icon={UserGroupIcon}
          href="/payroll/employees"
        />
        <PayrollCard
          title="Attendance"
          description="Mark and view attendance"
          icon={CalendarDaysIcon}
          href="/payroll/attendance"
        />
        <PayrollCard
          title="Leave Management"
          description="Manage employee leaves"
          icon={ClipboardDocumentCheckIcon}
          href="/payroll/leave"
        />
        <PayrollCard
          title="Salary"
          description="Generate and manage salaries"
          icon={CurrencyDollarIcon}
          href="/payroll/salary"
        />
        <PayrollCard
          title="Advance Payment"
          description="Manage advance payments"
          icon={BanknotesIcon}
          href="/payroll/advance-payment"
        />
      </div>
    </div>
  );
};

export default Payroll;

